const REQUEST_ID_STORAGE_KEY = 'portal.x-request-id';

export const createClientRequestId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `req_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
};

export const getOrCreateClientRequestId = (): string => {
  try {
    const existing = sessionStorage.getItem(REQUEST_ID_STORAGE_KEY)?.trim();
    if (existing) {
      return existing;
    }
  } catch {
    // sessionStorage indisponível
  }

  const created = createClientRequestId();

  try {
    sessionStorage.setItem(REQUEST_ID_STORAGE_KEY, created);
  } catch {
    // ignore
  }

  return created;
};

export const withRequestIdHeaders = (
  headers: Record<string, string> = {},
  requestId = getOrCreateClientRequestId(),
): Record<string, string> => ({
  ...headers,
  'X-Request-Id': requestId,
});

export const readResponseRequestId = (response: Response): string | null => (
  response.headers.get('x-request-id')?.trim() || null
);
